import Loading from '../components/Loading';
import TextInput from "../components/TextInput";
import FormError from "../components/FormError";
import TextareaInput from "../components/TextareaInput";
import FormInput from "../components/FormInput";
import PhoneInput from "../components/PhoneInput";
import FormAgreement from "../components/FormAgreement";

export default function LandingRequestFormContainer({
    landingName,
    url,
    goals = [], 
    fields = [],
    data = {},
    useAnimation = true,
    animationClass = 'slideRight',
    onSuccessSubmit,
    showCheckboxMedia = false,
    showFlagSelect = true,
    initialPhone = '',
}) {
    const [phone, setPhone] = React.useState(initialPhone);
    const [phoneCode, setPhoneCode] = React.useState(undefined);
    const [phoneComplete, setPhoneComplete] = React.useState(false);

    const [name, setName] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [noEmail, setNoEmail] = React.useState(false);
    const [comment, setComment] = React.useState('');
    const [agreeCb, setAgreeCb] = React.useState(false);
    const [agreeMedia, setAgreeMedia] = React.useState(false);

    const [errors, setErrors] = React.useState({});
    const [message, setMessage] = React.useState('');
    const [isFetching, setIsFetching] = React.useState(false);

    React.useEffect(() => {
        if (!fields.includes('email'))
            setNoEmail(true)
    }, []);
    
    const canSend = () => {
        return agreeCb && (!showCheckboxMedia || agreeMedia);
    }

    const handleSendRequest = () => {

        setIsFetching(true);
        setErrors({});

        if (!canSend()) {
            setMessage(__('request.form.termsAgreement'));
            setIsFetching(false);
            return;
        }

        let direction = data.direction || '';
        const dates = data.dates || '';
        const price = data.price || '';

        if (data.hotel)
            direction = `Отель ${data.hotel}${data.title ? (' ' + data.title) : ''}`;
        
        requestFormAction.sendLandingRequest({
            landingName, url, phone, phoneCode, name, email, noEmail, comment, direction, dates, price
        }).then(response => {
            setIsFetching(false);
            if (response.success) {
                clearForm();
                (goals || []).map((goal) => ymReachGoal(goal));
                onSuccessSubmit && onSuccessSubmit();
            } else {
                setErrors(response.errors || {});
                setMessage(response.message || '');
            }
        })
    }

    const hasErrors = () => {
        return Object.keys(errors).length > 0;
    }

    const getUnknownErrorsMessage = () => {

        if (!hasErrors()) return null;

        const unknown_errors = [];
        for (const key in errors)
            if (!fields.includes(key))
                unknown_errors.push(errors[key]);

        return unknown_errors.join('. ');
    }
    
    const clearForm = () => {
        setPhone('+');
        setPhoneComplete(false);
        setName('');
        setEmail('');
        setComment('');
        setAgreeCb(false);
        setAgreeMedia(false);
    }

    return <div className={clsx(['sf-form', useAnimation && 'wow', useAnimation && animationClass])} style={{position: 'relative'}} data-wow-delay="0.1s" data-wow-offset="100">
        {(fields || []).map(field => {
            const key = 'field_' + field;
            switch (field) {
                case 'phone':
                    return (
                        <div className="sf-form__row" key={key}>
                            <PhoneInput
                                inputClassName="input phone-input"
                                placeholder={__('hotels.form.phone')}
                                value={phone}
                                phoneCode={phoneCode}
                                onChange={phone => setPhone(phone)}
                                onCodeChange={phoneCode => setPhoneCode(phoneCode)}
                                onCompleteChange={phoneComplete => setPhoneComplete(phoneComplete)}
                                showFlagSelect = {showFlagSelect}
                            />
                            <FormError error={errors.phone}/>
                        </div>
                    );
                case 'name':
                    return (
                        <div className="sf-form__row" key={key}>
                            <TextInput
                                placeholder={__('hotels.form.name') + ' *'}
                                value={name}
                                onChange={value => setName(value)}
                            />
                            <FormError error={errors.name}/>
                        </div>
                    );
                case 'email':
                    return (
                        <div className="sf-form__row" key={key}>
                            <TextInput
                                type={'email'}
                                placeholder={__('request.form.email') + ' *'}
                                value={email}
                                onChange={value => setEmail(value)}
                            />
                            <FormError error={errors.email}/>
                        </div>
                    );
                case 'comment':
                    return (
                        <div className="sf-form__row" key={key}>
                            <TextareaInput
                                type={'textarea'}
                                placeholder={data.comment_placeholder || __('request.form.commentWriteOptions')}
                                value={comment}
                                onChange={value => setComment(value)}
                            />
                            <FormError error={errors.comment}/>
                            <FormError error={message}/>
                            <FormError error={getUnknownErrorsMessage()}/>
                        </div>
                    );
            }
        })}

        <div className="sf-form__checkbox">
            <FormAgreement
                agreeConditionsValue={agreeCb}
                agreeMediaValue={agreeMedia}
                onAgreeConditionsChange={value => setAgreeCb(value)}
                onAgreeMediaChange={value => setAgreeMedia(value)}
                textConditions={__('[Agreement] Text')}
                textMedia={__('[Agreement] Agree to media')}
            />
        </div>
        <div className="sf-form__btn">
            <button className="button2 sf-form__send" disabled={!canSend()} onClick={handleSendRequest}>
                {__('hotels.form.sendRequest')}
            </button>
        </div>
        <Loading active={isFetching}/>
    </div>
}